<!-- RC 首页 -->

<template>
  <div ref="wrapper" class="index-page-5">
    <div style="padding: 0 16px">
      <div class="header">
        <van-row justify="space-between" style="margin: 0 8px; padding: 8px 0" type="flex">
          <van-col span="18">
            <van-row type="flex">
              <van-col span="8">
                <van-image v-if="userInfo.avatar" :src="userInfo.avatar" height="48px" round style="margin-top: 4px"
                  width="48px" />
                <van-icon v-else color="#020202" name="user-circle-o" size="48" style="margin-top: 4px" />
              </van-col>
              <van-col span="16">
                <div class="index-v3-city-dropdown" style="margin-top: 6px">
                  <van-dropdown-menu :active-color="'#020202'">
                    <van-dropdown-item :title="$store.getters.city_name">
                      <van-tree-select :active-id.sync="activeId" :items="items" :main-active-index.sync="activeIndex"
                        @click-item="changeCity" />
                    </van-dropdown-item>
                  </van-dropdown-menu>
                  <div style="
                      margin-left: 8px;
                      color: #666;
                      width: 100%;
                      font-size: 15px;
                      margin-top: 2px;
                      font-weight: 500;
                    ">
                    {{ userInfo.nickName }}
                  </div>
                </div>
              </van-col>
            </van-row>
          </van-col>

          <van-col class="nav-top-right" span="6">
            <van-grid :border="false" :column-num="2" style="color: #666; font-size: 12px; width: 150px">
<!--
              <van-grid-item url="/v6/offline-swipe" text="到店">
                <template #icon>
                  <van-icon color="#fff"
                    name="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png"
                    size="32" />
                </template>
              </van-grid-item>
-->
              <van-grid-item to="/user-center-index" class="budo-47" text="我的">
                <template #icon>
                  <van-icon color="#fff"
                    name="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20250103/pkl2zzp0s7yopglrti27kz6r.png"
                    size="32" />
                </template>
              </van-grid-item>
              <van-grid-item @click="getUserService()" text="客服">
                <template #icon>
                  <van-icon color="#fff"
                    name="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/n6wngmwio8ovlnb0seuykkxn.png"
                    size="32" />
                </template>
              </van-grid-item>
            </van-grid>
          </van-col>
        </van-row>
      </div>
    </div>

    <!-- 通知公告栏 index v3 -->
    <BudoNoticeBar confKey="index_v3_notice" />

    <!-- 轮播广告图 -->
    <div style="margin-top: 16px; padding: 0 16px">
      <ads-images code="index_images"></ads-images>
    </div>

    <div v-if="loading" style="width: 100%; text-align: center; margin-top: 42px">
      <van-loading v-show="loading" color="#1989fa" size="24px" type="spinner"></van-loading>
    </div>

    <!-- 小图标 样式 -->
    <IndexCateListNew :allowCateInfo="allowCateInfo" :mall_modules="mall_modules" />

    <!-- 限时秒杀 v3 -->
    <van-cell v-if="goodsListByTime.length > 0" title="限时秒杀" value="全部 >" :border="false" @click="toModuleIndex('1')"
      style="padding-left: 15px" title-class="cell-title" :title-style="{ color: '#0090FF' }" value-class="cell-value">
    </van-cell>

    <div style="
        box-shadow: 0px 2px 8px 1px #e1e1e1;
        background: #fff;
        margin: 5px 15px 12px 15px;
        padding-top: 5px;
        border-radius: 8px;
      " v-if="goodsListByTime.length > 0">
      <div style="margin: 0 16px">
        <GoodsListV3Block :cate-id="1" :tags="GOODS_TAGS.hot" :visible-pay="false" />
      </div>
    </div>

    <!-- 精选好物 -->
    <van-cell title="精选好物" value="全部 >" :border="false" title-class="cell-title" value-class="cell-value"
      @click="toModuleIndex()"></van-cell>

    <van-tabs v-model="activeTabId" color="#fff" line-width="0">
      <van-tab v-if="allowStoreIndexFlag === 1" name="1">
        <template #title>
          <van-button color="rgb(0,144,255)" round size="mini" v-if="activeTabId === '1'"
            style="font-size: 15px; font-weight: bold">
            &nbsp;&nbsp;商 城&nbsp;&nbsp;
          </van-button>

          <span v-else style="font-size: 15px; font-weight: bold">商 城</span>
        </template>

        <van-list v-model="goodsLoading" :error.sync="error" :finished="finished" :finished-text="finishedText"
          error-text="请求失败，点击重新加载 F" @load="getGoodsList">
          <div class="list">
            <!-- 商品左列 -->
            <div class="list-col">
              <div v-for="(goods, index) of goodsListByPromotion" :key="index">
                <div v-if="index % 2 === 0" class="list-item">
                  <van-image :src="goods.headImage ||
                    'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png'
                    " style="min-width: 30vw; min-height: 30vw" fit="contain" radius="8px 8px 0 0" @click="
                      $router.push({
                        path: 'goods-detail',
                        query: { goodsId: goods.goodsId },
                      })
                      " />

                  <div style="
                      font-size: 15px;
                      font-weight: 400;
                      margin-top: 8px;
                      padding: 8px;
                      text-align: left;
                    " @click="
                      $router.push({
                        path: 'goods-detail',
                        query: { goodsId: goods.goodsId },
                      })
                      ">
                    <van-tag v-for="tag in goods.tags" :key="tag" color="#f55519" style="
                        font-size: 14px;
                        padding: 0 4px;
                        line-height: normal; ">{{ tag }}
                    </van-tag>
                    {{ goods.name }}
                  </div>
                  <div class="goods_price">
                    <div class="price">
                      <img class="icon"
                        src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                      <span class="text" v-html="$options.filters.moneyFormatFilter(goods.price)"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 商品右列 -->
            <div class="list-col">
              <div v-for="(goods, index) of goodsListByPromotion" :key="index">
                <div v-if="index % 2 !== 0" class="list-item">
                  <van-image :src="goods.headImage ||
                    'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png'
                    " style="min-width: 30vw; min-height: 30vw" fit="contain" radius="8px 8px 0 0" @click="
                      $router.push({
                        path: 'goods-detail',
                        query: { goodsId: goods.goodsId },
                      })
                      " />
                  <div style="
                      font-size: 15px;
                      font-weight: 400;
                      margin-top: 8px;
                      padding: 8px;
                      text-align: left;
                    " @click="
                      $router.push({
                        path: 'goods-detail',
                        query: { goodsId: goods.goodsId },
                      })
                      ">
                    <van-tag v-for="tag in goods.tags" :key="tag" color="#f55519" style="
                        font-size: 14px;
                        padding: 0 4px;
                        line-height: normal; ">{{ tag }}
                    </van-tag>
                    {{ goods.name }}
                  </div>
                  <div class="goods_price">
                    <div class="price">
                      <img class="icon"
                        src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                      <span class="text" v-html="$options.filters.moneyFormatFilter(goods.price)"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>

      <van-tab v-if="allowMovieFlag === 1" name="2">
        <template #title>
          <van-button color="rgb(0,144,255)" round size="mini" v-if="activeTabId === '2'"
            style="font-size: 15px; font-weight: bold">&nbsp;&nbsp;电 影&nbsp;&nbsp;
          </van-button>
          <span v-else style="font-size: 15px; font-weight: bold">电 影</span>
        </template>

        <div class="masonry">
          <div class="item" v-for="(movie, index) of movieDataList" :key="index">
            <van-image :src="movie.logo" fit="contain" radius="8px 8px 0 0" />
            <div style="
                font-size: 15px;
                font-weight: 400;
                margin-top: 8px;
                padding: 8px;
                text-align: left;
              "> {{ movie.name }} </div>
            <div style="
                font-size: 12px;
                margin-left: 8px;
                margin-bottom: 8px;
                text-align: left;
              ">
              <van-tag plain style="font-size: 12px" type="warning">{{ movie.rating }}分</van-tag>
              <van-tag plain v-if="movie.showmark" style="margin-left: 2px; font-size: 12px" color="#E4E4E4"
                text-color="#7F8699">
                {{ movie.showmark }}
              </van-tag>
            </div>

            <div style="">
              <van-button size="mini" style="width: 60px; font-size: 14px; margin: 8px 0" type="info"
                @click="toMovieDetail(movie.id, movie.name)">
                购 票
              </van-button>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab :title="module.extNameV3" :name="module.topCateId" v-for="(module, index) of commonCateList"
        :key="index">
        <template #title>
          <van-button color="rgb(0,144,255)" round size="mini" v-if="activeTabId === module.topCateId"
            style="font-size: 15px; font-weight: bold">
            &nbsp;&nbsp;{{ module.extNameV3 }}&nbsp;&nbsp;
          </van-button>
          <span v-else style="font-size: 15px; font-weight: bold">{{ module.extNameV3 }}</span>
        </template>

        <div class="masonry">
          <div class="item" v-for="(goods, index) of goodsList" :key="index">
            <van-image :src="goods.headImage" fit="contain" lazy-load radius="8px 8px 0 0" @click="
              $router.push({
                path: 'goods-detail',
                query: { goodsId: goods.goodsId },
              })
              " />
            <div style="
                font-size: 15px;
                font-weight: 400;
                margin-top: 8px;
                padding: 8px;
                text-align: left;
              " @click="
                $router.push({
                  path: 'goods-detail',
                  query: { goodsId: goods.goodsId },
                })
                ">
              {{ goods.name }}
            </div>
            <div class="goods_price">
              <div class="price">
                <img class="icon"
                  src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                <span class="text" v-html="$options.filters.moneyFormatFilter(goods.price)"></span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab v-if="allowTravelFlag === 1" title="门票" name="7">
        <template #title>
          <van-button color="rgb(0,144,255)" round size="mini" v-if="activeTabId === '7'"
            style="font-size: 15px; font-weight: bold">
            &nbsp;&nbsp;门 票&nbsp;&nbsp;
          </van-button>
          <span v-else style="font-size: 15px; font-weight: bold">门 票</span>
        </template>

        <div class="masonry">
          <div class="item" v-for="(goods, index) of travelData.records" :key="index" @click="
            $router.push({
              path: 'travel-detail',
              query: { id: goods.brandShopId },
            })
            ">
            <van-image :src="goods.logo" fit="contain" lazy-load radius="8px 8px 0 0" />
            <div style="
                font-size: 15px;
                font-weight: 400;
                margin-top: 8px;
                padding: 8px;
                text-align: left;
              ">
              {{ goods.name }}
            </div>

            <div style="
                font-size: 12px;
                margin-left: 8px;
                margin-bottom: 8px;
                text-align: left;
              ">
              <van-tag plain type="warning" v-if="getExtInfo(goods.extInfo).commentGrade > 0">
                {{ getExtInfo(goods.extInfo).commentGrade }}分
              </van-tag>
              <van-tag plain style="margin-left: 2px" color="#E4E4E4" text-color="#7F8699">
                {{ goods.distance }}km
              </van-tag>
            </div>

            <div class="goods_price">
              <div class="price">
                <img class="icon"
                  src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                <span class="text" v-html="$options.filters.moneyFormatFilter(goods.goodsMinPrice, '起')"></span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab v-if="allowHealthFlag === 1" title="体检" name="8">
        <template #title>
          <van-button color="rgb(0,144,255)" round size="mini" v-if="activeTabId === '8'"
            style="font-size: 15px; font-weight: bold">
            &nbsp;&nbsp;体 检&nbsp;&nbsp;
          </van-button>
          <span v-else style="font-size: 15px; font-weight: bold">体 检</span>
        </template>

        <div class="masonry">
          <div class="item" v-for="(goods, index) of healthData.records" :key="index" @click="
            $router.push({
              path: 'health-detail',
              query: { id: goods.brandShopId },
            })
            ">
            <van-image :src="goods.headImage" fit="contain" lazy-load radius="8px 8px 0 0" />
            <div style="
                font-size: 15px;
                font-weight: 400;
                margin-top: 8px;
                padding: 8px;
                text-align: left;
              ">
              {{ goods.name }}
            </div>

            <div style="
                font-size: 12px;
                margin-left: 8px;
                margin-bottom: 8px;
                text-align: left;
              ">
              <van-tag plain type="warning">{{ goods.level }}</van-tag>
              <van-tag plain style="margin-left: 2px" color="#E4E4E4" text-color="#7F8699">{{ goods.distance }}km
              </van-tag>
            </div>

            <div class="goods_price">
              <div class="price">
                <img class="icon"
                  src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                <span class="text" v-html="$options.filters.moneyFormatFilter(goods.minPrice, '起')
                  "></span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
import CitySelect from "@/components/common/city-select";
import AdsImages from "@/components/common/ads-images";
import {
  api_get_goods_list_by_params,
  get_goods_list_by_store_index,
  wx_get_goods_list_by_topic,
  api_get_hospital_list,
  api_get_hot_movie_list,
  api_get_scenic_spot_list,
  mall_WxUser_get_TopicList_ByUser,
  api_get_user_cate_id_list,
} from "@/api/goods-api";
import store from "@/store";
import { areaList } from "@vant/area-data";
import { GOODS_TAGS } from "@/api/constant";
import { wx_get_location_cached } from "@/util/wxSdk";
import { mall_util_order_buy_goods } from "@/util/orders";

import GoodsListBlockV3 from "@/components/common/GoodsListV3Block.vue";
import BudoNoticeBar from "@/components/BudoNoticeBar.vue";

import request from "@/util/axios";

import { change_city_by_location } from "@/util/LocationUtil";
import { $wx_kefu_rc } from "@/util/wxSdk";
import { MallModules } from "@/api/constant";

Vue.use(Lazyload);

export default {
  name: "index",

  computed: {
    GOODS_TAGS() {
      return GOODS_TAGS;
    },

    userInfo() {
      return this.$store.getters.userInfo;
    },

    colCount() {
      const c =
        this.allowCateInfo.length % 4 === 0
          ? Math.floor(this.allowCateInfo.length / 4)
          : Math.floor(this.allowCateInfo.length / 4) + 1;
      budo_log.debug("#357 colCount", c);
      return c;
    },
  },

  components: { AdsImages, CitySelect, GoodsListBlockV3, BudoNoticeBar },

  data() {
    return {
      mall_modules: [], // 顶级目录

      areaList,
      items: [],
      activeId: 5101,
      activeIndex: 0,
      active: 0,
      movieDataList: [],
      allowCateInfo: [],
      allowMovieFlag: 0,
      allowHealthFlag: 0,
      allowTravelFlag: 0,
      allPrivilegeFlag: 0,
      allowStoreIndexFlag: 0,
      commonCateList: [],
      travelData: {},
      healthData: {},
      loading: true,
      activeTabId: "",
      goodsListByTime: [], // 热卖商品
      goodsList: [],
      error: false,
      goodsLoading: false,
      finished: false,
      finishedText: "没有更多了 Q",
      pi: 0,
      goodsListByPromotion: [], //促销商品
      sortStr: "price.ascend",

      birthdayModule: {
        name: "birthday",
        index: "/birthday",
        addToCart: false,
        extName: "生日/Birthday",
        iconImg: "images/index-new/class/shengridangao.svg",
        indexNavFlag: 3,
        topCateId: 3,
        title: "生日",
        extNameV3: "生  日",
        iconImgV3:
          "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/rzh4qumz243dufwe38aj0xu4.png",
        textColor: "#FF7C0E",
      },
    };
  },

  watch: {
    activeTabId(v1, v2) {
      budo_log.debug("#396 watch activeTabId", v1, v2);

      const cateId = parseInt(v1);
      if (2 !== cateId && 7 !== cateId && 8 !== cateId && 1 !== cateId) {
        get_goods_list_by_store_index({
          cateId: cateId,
          pi: 0,
          ps: 20,
          tag: GOODS_TAGS.recommend,
        }).then((res) => {
          this.goodsList = res.data.records;
        });
      }
    },
  },

  // 页面标题 这个页面是 keepAlive 的 所以用 activated
  activated() {
    var userInfo = sessionStorage.getItem("rc-25-userInfo") || "{}";
    var indexPageTitle = JSON.parse(userInfo).content?.indexPageTitle;
    document.title = indexPageTitle || "首页 - 福利";
  },

  mounted() {
    window.onscroll = this.doScroll;

    //加载城市列表
    this.loadCityList();
    this.getMovieList();

    // 从后台拿所有顶级目录
    request.post("/mall/wx/wx-user-root-cate-list").then((res) => {
      // 所有顶级目录
      this.mall_modules = res?.data?.map((e) => {
        e.topCateId = e.cateId; // ID
        e.indexNavFlag = e.sort || e.cateId; // 排序
        e.iconImgV3 = e.icon; // 图标
        e.extNameV3 = e.name; // 显示名
        // textColor
        return e;
      }) || []; // MallModules

      // 增加一个特殊的 专属定制 getAllowCateList 有是否展示这个的逻辑
      this.mall_modules.push(MallModules.filter((e) => 999 == e.topCateId)[0]);

      // 看客户开通了哪些目录
      this.getAllowCateList();
    });
  },

  created() {
    wx_get_location_cached(() => {
      var lat = sessionStorage.getItem("USER_CURRENT_POI_LAT");
      var lng = sessionStorage.getItem("USER_CURRENT_POI_LNG");

      budo_log.debug("#424 get_user_poi_location", lat, lng);

      // 如果定位位置和选择的位置不同 就提醒用户切换
      change_city_by_location(lat, lng);
    });
  },

  methods: {
    addCart(goodsId) {
      mall_util_order_buy_goods(goodsId, 1, true);
    },

    getUserService() {
      location.href = $wx_kefu_rc();
    },

    toModuleIndex(cateId = "", targetUrl) {
      budo_log.info("#471 toModuleIndex", cateId, targetUrl);

      if (targetUrl) {
        location.href = targetUrl;
        return;
      }

      let id = 0;
      if (cateId) {
        id = parseInt(cateId);
      } else {
        id = parseInt(this.activeTabId);
      }

      if (id === 2) {
        location.href = "/movie/index";
        return;
      }

      // 专题列表
      if (id === 999) {
        this.$router.push("/topic-list");
        return;
      }

      let mid = id;

      let module = this.mall_modules.find((mall) => mall.topCateId === mid);
      if (id === 3) {
        module = this.birthdayModule;
      }

      if (module) {
        this.$store.commit("SET_MALL_MODULE", module);
        sessionStorage.setItem("rc.module-info", JSON.stringify(module));

        this.$store.commit("CLEAR_CART");
        this.$EventBus.$emit("routeInfo", JSON.stringify(module || {}));

        budo_log.info("#509 module_name", module);
      }

      this.$router.push(this.getModuleIndexUrl(id));
    },

    toMovieDetail(id, name) {
      location.href = "/movie/cinema?movieId=" + id + "&movieName=" + name;
    },

    getModuleIndexUrl(cateId) {
      switch (cateId) {
        case 3:
          return "/birthday";
        case 1:
          return "/index";
        case 7:
          return "/travel-index";
        case 8:
          return "/health-index";
        default:
          return "/common-index?cateId=" + cateId;
      }
    },

    getHealthData() {
      api_get_hospital_list(0, 10, "", "", "").then((res) => {
        this.allowHealthFlag = 1;
        if (res.code === 0) {
          this.healthData = {
            records: [].concat(
              res.data.records.map((r) => {
                if (r && r.goodsList && r.goodsList.length > 0) {
                  r.minPrice = r.goodsList[0].price;
                  r.goodsList.sort((a, b) => a.price - b.price)
                }
                return r;
              })
            ),
            id: 8,
          };
        } else {
          budo_log.info("#514 获取体验医院数据失败");
        }
      });
    },

    getTravelData() {
      api_get_scenic_spot_list(this.pi, 10, "", 0, 1, 0, 0).then((res) => {
        this.allowTravelFlag = 1;
        this.travelData = {
          id: 7,
          records: res.data.records.filter((g) => g.goodsCount > 0),
        };
      });
    },

    getExtInfo(str) {
      const extInfo = JSON.parse(str);
      return extInfo || {};
    },

    getAllowCateList() {
      api_get_user_cate_id_list().then((res) => {
        this.loading = false;

        if (res.code == 1) {
          this.allowMovieFlag = 0;
          this.allowCateInfo = []; // 无卡的啥板块都不展示 估计之前印钞投标 特殊改过

          // 没有可用卡券 B 这里不 alert 让 App 那边引导用户去绑手机绑卡
          // Dialog.alert({ message: res.msg || "获取用户板块失败" })
          return;
        }

        if (res.code == 0) {
          const allowCateId = res.data;
          const commonCateIdList = allowCateId.slice();
          budo_log.debug("#546 commonCateIdList", commonCateIdList);
          // 737 = 成都工务大型养路机械运用检修段委员会
          // 745 = 彭州市人民医院
          if (
            this.userInfo.customerId === 737 ||
            this.userInfo.customerId === 745
          ) {
            const index = allowCateId.findIndex((id) => id === 15);
            if (index !== -1) {
              allowCateId.splice(index, 1);
            }
          }

          mall_WxUser_get_TopicList_ByUser().then((topicRes) => {
            if (topicRes.code === 0 && topicRes.data) {
              this.allPrivilegeFlag = 1;
            }

            // 特权频道
            if (this.allPrivilegeFlag) {
              allowCateId.push(999); // 专属定制
            }

            // 允许电影
            if (allowCateId.findIndex((item) => item === 2) >= 0) {
              this.allowMovieFlag = 1;
              commonCateIdList.splice(commonCateIdList.indexOf(2), 1);
            }

            if (allowCateId.findIndex((item) => item === 7) >= 0) {
              commonCateIdList.splice(commonCateIdList.indexOf(7), 1);
              this.getTravelData();
            }

            if (allowCateId.findIndex((item) => item === 8) >= 0) {
              commonCateIdList.splice(commonCateIdList.indexOf(8), 1);
              this.getHealthData();
            }

            if (allowCateId.findIndex((item) => item === 1) >= 0) {
              commonCateIdList.splice(commonCateIdList.indexOf(1), 1);
              this.allowStoreIndexFlag = 1;

              // 热卖
              wx_get_goods_list_by_topic(7, "", 1, 4).then((res) => {
                this.goodsListByTime = res.data.records;
              });
            }

            const modules = this.mall_modules.slice();
            if (
              allowCateId.findIndex((item) => item === 3) >= 0 && // 允许列表有生日蛋糕 但分类列表没有
              this.mall_modules.findIndex((e) => e.cateId == 3) < 0
            ) {
              // 如果分类列表返回了蛋糕 就不再加一个了
              modules.push(this.birthdayModule);
            }

            budo_log.debug("#594 commonCateIdList", commonCateIdList);
            this.allowCateInfo = modules.filter((f) =>
                  allowCateId.findIndex((item) => item === f.topCateId) >= 0 &&
                  f.indexNavFlag > 0 ).sort((a, b) => a.indexNavFlag - b.indexNavFlag);

            budo_log.debug("#599 allowCateInfo", this.allowCateInfo);

            this.commonCateList = modules.filter( (f) =>
                  commonCateIdList.findIndex((item) => item === f.topCateId) >=
                  0 && f.indexNavFlag > 0 ).sort((a, b) => a.indexNavFlag - b.indexNavFlag);

            budo_log.debug( "#648 commonCateList=", this.commonCateList, "commonCateIdList=", commonCateIdList, "allowCateId", allowCateId, "modules", modules );
          });
        }
      });
    },

    getMovieList() {
      api_get_hot_movie_list().then((res) => {
        budo_log.debug("#610 getMovieList", res);
        this.movieDataList = res?.data?.movieList || [];
      });
    },

    loadCityList() {
      //加载城市列表
      for (const pid in this.areaList.province_list) {
        const node = {
          text: this.areaList.province_list[pid],
          children: [],
        };

        const cityList = [];
        for (const cid in this.areaList.city_list) {
          if (cid.substring(0, 2) === pid.substring(0, 2)) {
            cityList.push({ text: this.areaList.city_list[cid], id: cid });
          }
        }

        node.children = cityList;
        this.items.push(node);
      }
      this.active = this.$store.getters.city_code;
    },

    changeCity(data) {
      budo_log.info("#688 changeCity SET_CITY_NAME", data);

      store.commit("SET_CITY_CODE", data.id.substring(0, 4));
      store.commit("SET_CITY_NAME", data.text);
      window.location.reload();
    },

    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
      }, 300);
    },

    forbidBack() {
      window.history.pushState("forward", null, "#");
      window.history.forward(1);
    },

    getGoodsList() {
      this.finishedText = "加载中 F ...";

      this.pi++;
      budo_log.debug("#654 getGoodsList, pi=", this.pi);
      let params = {
        pi: this.pi,
        ps: 10,
        cateId: 1,
        sortStr: this.sortStr,
      };

      // 促销标签商品
      api_get_goods_list_by_params(params).then((res) => {
        budo_log.debug("#664 api_get_goods_list_by_params, res=", res, "params=", params);

        this.goodsListByPromotion = this.goodsListByPromotion.concat(
          res.data.records
        );

        // 后端默认不查总数(total 恒为 0)，按本次返回条数是否不足一页判断是否到底
        if (res.data.records.length < params.ps) {
          this.finishedText =
            this.goodsListByPromotion.length === 0
              ? "看看其它的吧 G"
              : "没有更多了 R";
          this.finished = true;
        }

        this.goodsLoading = false;
      }).catch((error) => {
        budo_log.info("#701 api_get_goods_list_by_params, error", error);

        this.goodsLoading = false;
        this.error = true;
      });
    },
  },

  // 处理ios url兼容
  beforeRouteEnter(to, from, next) {
    if (
      "/web" + to.path !== location.pathname ||
      "/web" + to.path !== "/web" + to.fullPath
    ) {
      location.assign("/web" + to.fullPath.split("?")[0]);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "index";

@media screen and (max-width: 800px) {
  .masonry {
    column-count: 2;
  }
}

.masonry {
  -moz-column-count: 2;
  /* Firefox */
  -webkit-column-count: 2;
  /* Safari 和 Chrome */
  column-count: 2;
  -moz-column-gap: 2em;
  -webkit-column-gap: 2em;
  column-gap: 16px;
  width: 90%;
  margin: 8px auto;
}

.item {
  //padding: 1em;
  margin-bottom: 16px;
  -moz-page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
  break-inside: avoid;
  background: #fff;
  text-align: center;
  border-radius: 8px;
  color: #010101;
  box-shadow: 0px 2px 8px 1px rgba(234, 234, 234, 0.67);
}

.list {
  margin: 8px 7px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.list-col {
  display: flex;
  flex-direction: column;
  width: 50%;
  box-sizing: border-box;
}

.list-item {
  margin: 8px;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 1px rgba(234, 234, 234, 0.67);
}
</style>
